import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

export function WheelAutoPopup() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [glowing, setGlowing] = useState(false);
  
  useEffect(() => {
    // POPUP SE UVEK POJAVLJUJE - bez hasSpunToday provere
    const timer = setTimeout(() => setVisible(true), 6000);
    return () => clearTimeout(timer);
  }, []);
  
  useEffect(() => {
    const interval = setInterval(() => setGlowing(g => !g), 900);
    return () => clearInterval(interval);
  }, []);
  
  // Scroll lock je uklonjen - korisnik može da scrolluje pozadinu
  
  if (!visible) return null;
  
  const popupContent = (
    <div
      id="wheel-auto-popup-overlay"
      data-testid="wheel-popup"
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        width: "100vw",
        height: "100vh",
        zIndex: "999999",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
        background: "rgba(0,0,0,0.75)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
      onClick={() => setVisible(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "radial-gradient(ellipse at top, #1a003e, #0a0015)",
          border: "2px solid rgba(251,191,36,0.5)",
          borderRadius: "1.5rem",
          padding: "2rem 1.5rem",
          maxWidth: 340,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 0 60px rgba(124,58,237,0.4), 0 0 120px rgba(251,191,36,0.15)",
          position: "relative",
        }}
      >
        {/* Zatvori */}
        <button
          onClick={() => setVisible(false)}
          style={{
            position: "absolute", top: "0.75rem", right: "0.75rem",
            background: "none", border: "none", color: "rgba(255,255,255,0.4)",
            fontSize: "1.2rem", cursor: "pointer", lineHeight: 1,
          }}
        >✕</button>
        
        {/* Ikona */}
        <div style={{
          fontSize: "3.5rem",
          marginBottom: "1rem",
          filter: "drop-shadow(0 0 20px rgba(251,191,36,0.6))",
        }}>
          🔮
        </div>
        
        {/* Naslov */}
        <h2 style={{
          fontSize: "1.5rem",
          fontWeight: "bold",
          color: "#fbbf24",
          marginBottom: "0.75rem",
          textShadow: "0 0 20px rgba(251,191,36,0.4)",
        }}>
          Astrološki Točak Sreće
        </h2>
        
        <p style={{
          color: "rgba(196,181,253,0.85)",
          fontSize: "0.9rem",
          marginBottom: "1.25rem",
          lineHeight: 1.5,
        }}>
          Zavrti točak i osvoji do 50% popusta na astrološku analizu!
        </p>
        
        {/* Nagrade preview */}
        <div style={{
          display: "flex",
          gap: "0.5rem",
          justifyContent: "center",
          marginBottom: "1.5rem",
          flexWrap: "wrap",
        }}>
          {["10%", "20%", "30%", "50%", "🎁", "🔮"].map((label, i) => (
            <div
              key={i}
              style={{
                background: "rgba(251,191,36,0.15)",
                border: "1px solid rgba(251,191,36,0.3)",
                borderRadius: "0.5rem",
                padding: "0.4rem 0.7rem",
                fontSize: "0.75rem",
                fontWeight: "bold",
                color: "#fde68a",
              }}
            >
              {label}
            </div>
          ))}
        </div>
        
        {/* CTA dugme */}
        <button
          onClick={() => { setVisible(false); navigate("/wheel"); }}
          style={{
            width: "100%",
            padding: "1rem",
            borderRadius: "9999px",
            background: "linear-gradient(90deg, #b45309, #d97706, #fbbf24)",
            color: "#1e003e",
            fontWeight: "bold",
            fontSize: "1.1rem",
            border: "none",
            cursor: "pointer",
            boxShadow: glowing
              ? "0 0 40px rgba(251,191,36,0.9), 0 0 80px rgba(251,191,36,0.3)"
              : "0 0 15px rgba(251,191,36,0.4)",
            transition: "box-shadow 0.8s ease",
            marginBottom: "0.75rem",
          }}
        >
          🎰 Zavrti Točak Sreće!
        </button>
        
        <p style={{
          color: "rgba(196,181,253,0.5)",
          fontSize: "0.72rem",
        }}>
          Jedna šansa dnevno · Bez registracije
        </p>
        
        {/* Zvjezdice deko */}
        <div style={{
          position: "absolute",
          top: "1rem",
          left: "1rem",
          color: "rgba(251,191,36,0.3)",
          fontSize: "0.8rem",
        }}>✦ ✦ ✦</div>
        <div style={{
          position: "absolute",
          bottom: "1rem",
          right: "1rem",
          color: "rgba(251,191,36,0.3)",
          fontSize: "0.8rem",
        }}>✦ ✦ ✦</div>
      </div>
    </div>
  );
  
  return createPortal(popupContent, document.body);
}
